import React, { useState, useRef, useEffect } from "react";
import TablePagesTitle from "../../components/table-pages-title/TablePagesTitle";
import AccessPageAction from "../accessmanagment/page-action/AccessPageAction";
import { useNavigate, useParams } from "react-router-dom";
import "./smstemplate.scss";
import {
  alertActions,
  buttonName,
  createSmstemp,
  editEmailTemp,
  editSmsTemp,
  fieldValidation,
  smsTemplate,
  tooltips
} from "../../locales/en";
import {
  editTemplateSmsTemplateDataThunk,
  getfetchSmsTemplateDataThunk
} from "../../redux/smsTemplateSlice";
import { useDispatch } from "react-redux";
import { SMS_TEMPLATES } from "../../route/paths";

const EditSmsTemplate = () => {
  const { id } = useParams();
  const initialRender = useRef(true);

  const [templateName, setTemplateName] = useState("");
  const [description, setDescription] = useState("");
  const [smsContent, setSmsContent] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isDynamic, setIsDynamic] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const templateNameRef = useRef(templateName);
  const descriptionRef = useRef(description);

  const [templateNameError, setTemplateNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [smsContentError, setSmsContentError] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePreviewClick = () => {
    setIsEditing(true);
  };

  const handleRest = () => {
    setIsEditing(false);
  };
  const fetchSmsTemplate = async () => {
    try {
      const response = await dispatch(
        getfetchSmsTemplateDataThunk(Number(id))
      ).unwrap();

      const data = response.data.data;

      setTemplateName(data?.templateName || "");
      setDescription(data?.triggerDescription || "");
      setSmsContent(data?.smsContent || "");
      setIsActive(data?.isActive ?? false);
      setIsDynamic(data?.isDynamic ?? false);
    } catch {
      //handle error
    }
  };

  const handleSmsChange = (e) => {
    setSmsContent(e.target.value);
    setSmsContentError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;

    if (!templateName) {
      setTemplateNameError(fieldValidation.required);
      isValid = false;
    }
    if (!description) {
      setDescriptionError(fieldValidation.required);
      isValid = false;
    }
    if (!smsContent) {
      setSmsContentError(fieldValidation.required);
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    try {
      const updatedSmsTemplate = {
        templateName: templateName,
        triggerDescription: description,
        smsContent: smsContent,
        isActive: isActive,
        isDynamic: isDynamic
      };
      await dispatch(
        editTemplateSmsTemplateDataThunk({
          id: Number(id),
          data: updatedSmsTemplate
        })
      ).unwrap();

      navigate(SMS_TEMPLATES);
    } catch {
      // handle catch here;
    }
  };

  const handleFieldBlur = async (e) => {
    const { name, value } = e.target;

    if (name === "templateName") {
      setTemplateName(value);
      setTemplateNameError("");
    }
    if (name === "description") {
      setDescription(value);
      setDescriptionError("");
    }

    let isValid = true;

    if (!templateName) {
      setTemplateNameError(fieldValidation.required);
      isValid = false;
    }
    if (!description) {
      setDescriptionError(fieldValidation.required);
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    if (
      templateNameRef.current === templateName &&
      descriptionRef.current === description
    ) {
      return;
    }

    try {
      const updatedSmsTemplate = {
        templateName: templateName,
        triggerDescription: description,
        smsContent: smsContent,
        isActive: isActive,
        isDynamic: isDynamic
      };

      await dispatch(
        editTemplateSmsTemplateDataThunk({
          id: Number(id),
          data: updatedSmsTemplate
        })
      ).unwrap();

      templateNameRef.current = templateName;
      descriptionRef.current = description;
    } catch {
      // handle catch here;
    }
  };

  const handleCancel = () => {
    navigate(SMS_TEMPLATES);
  };

  const listItems = [
    "{{$owner_first_name}}",
    "{{$customer_name}}",
    "{{$FT_user_preferred_name}}",
    "{{$FT_AU_phone_number}}",
    "{{$FT_NZ_phone_number}}",
    "{{$Rick_AU_phone_number}}",
    "{{$Rick_NZ_phone_number}}",
    "{{$FT_user_phone_number_NZ_or_AU}}",
    "{{$FT_AU_bank_account_number}}",
    "{{$FT_NZ_bank_account_number}}",
    "{{$to_fund_page_link}}",
    "{{$funded_page_link}}",
    "{{$finish_signing_up_page_link}}"
  ];

  useEffect(() => {
    if (initialRender.current) {
      fetchSmsTemplate();
      initialRender.current = false;
    }
  }, [fetchSmsTemplate]);

  return (
    <>
      <TablePagesTitle
        mainTitle={smsTemplate.mainTitle}
        content={editSmsTemp.content}
      />
      <AccessPageAction subheading={`${editSmsTemp.subh2} "${templateName}"`} />
      <div className="row mt-3">
        <div className="col-md-4 col-lg-3">
          <div className="dynamic-content-section mb-3">
            <label htmlFor="dymicContent">
              <strong>{editEmailTemp.dymicContent}</strong>
            </label>
            <div className="mt-2">
              <ul className="ms-5 template-list">
                {listItems.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
          <div className="input-group-wrap mb-3">
            <label className="mb-1" htmlFor="templateName">
              <strong>{editEmailTemp.templateName}</strong>
            </label>
            <input
              type="text"
              placeholder={createSmstemp.templatePlaceholder}
              name="templateName"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              onBlur={handleFieldBlur}
            />
            {templateNameError && (
              <p className="error-message text-danger">
                <small>{templateNameError}</small>
              </p>
            )}
          </div>
          <div className="input-group-wrap mb-2">
            <label className="mb-1" htmlFor="triggerDescription">
              <strong>{editEmailTemp.triggerDescription}</strong>
            </label>
            <textarea
              name="description"
              placeholder={editEmailTemp.triggerDescription}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              onBlur={handleFieldBlur}
            />
            {descriptionError && (
              <p className="error-message text-danger">
                <small>{descriptionError}</small>
              </p>
            )}
          </div>
        </div>
        <div className="col-md-8 col-lg-9">
          <div className="preview-section mb-3">
            <div className="title-area border-bottom mb-3">
              <h2>{editEmailTemp.templatePreview}</h2>
            </div>
            <div className="preview-box" onClick={handlePreviewClick}>
              <div>{smsContent || createSmstemp.smsContent}</div>
            </div>
          </div>
          {isEditing && (
            <div className="input-group-wrap mb-2">
              <textarea
                name="sms_content"
                placeholder={createSmstemp.templatePreview}
                id="sms-content"
                value={smsContent}
                onChange={handleSmsChange}
              />
              {smsContentError && (
                <p className="error-message text-danger">
                  <small>{smsContentError}</small>
                </p>
              )}
            </div>
          )}
        </div>
        <div className="col-md-8 col-lg-9 offset-md-4 offset-lg-3">
          <div className="created-buttongroup d-flex">
            {isEditing && (
              <>
                <button
                  type="submit"
                  className="btn btn-primary me-2"
                  onClick={handleSubmit}
                >
                  {buttonName.update}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary me-2"
                  onClick={handleRest}
                >
                  {tooltips.reset}
                </button>
              </>
            )}
            <button
              type="button"
              className="btn btn-secondary btn-red"
              onClick={handleCancel}
            >
              {alertActions.Cancel}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSmsTemplate;
